// Module
var code = "<div style=font-size:13px;padding-left:5px;white-space:nowrap ng-style=\"{'border-left': '5px solid ' + polygonData.model.color}\"> {{ polygonData.model.name }} </div>";
// Exports
module.exports = code;